import React from "react";
import InvoiceServerRequest from "../invoice_server_request";
import InvoiceForm from "../components/invoice_form";

class InvoiceFormContainer extends React.Component {
  state = {
    schoolName: this.props.schoolName,
    quantity: this.props.quantity,
    disableFields: false,
    accountingContactEmail: "",
    accountingContactName: "",
    invitationAdministratorEmail: ""
  };

  handleChange = (e) => {
    const input = e.target;

    this.setState({
      [input.name]: input.value
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({
      disableFields: true
    });

    InvoiceServerRequest.bind(this)();
  };

  disableFields = () => (this.state.disableFields ? "disabled" : "");

  render() {
    return (
      <InvoiceForm
        disableFields={this.disableFields()}
        handleSubmit={this.handleSubmit}
        handleChange={this.handleChange}
        quantity={this.props.quantity}
        schoolName={this.state.schoolName}
        buttonText={this.props.buttonText}
      />
    );
  }
}

export default InvoiceFormContainer;
